import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { userLogout } from "@/store/user/userSlice"; // Update path as needed

const AUTO_LOGOUT_TIME = 60 * 60 * 1000; // 1 hour

const useAutoLogout = () => {
  const dispatch = useDispatch();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      dispatch(userLogout());
    }, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
    // Reset timer on user interaction
    const handleActivity = () => resetTimer();

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("touchstart", handleActivity);

    resetTimer(); // Start the timer

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
    };
  }, [dispatch]);

  return null; // No UI elements needed
};

export default useAutoLogout;
